
const copyUrl = (thisElm) => {
  const clipboardText = window.location.href;
  navigator.clipboard.writeText(clipboardText);
  thisElm.querySelector('.copied-notice').classList.remove('hidden');

  setTimeout(() => {
    thisElm.querySelector('.copied-notice').classList.add('hidden');
  }, 2000);
}

const shareOnSocialMedia = (platform) => {

  let shareUrl;
  let popUpWindow = true;

  switch (platform) {

    case "facebook":
      shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=';
      break;
    case "twitter":
      shareUrl = 'https://twitter.com/intent/tweet?url=';
      break;
    case "linkedin":
      shareUrl = 'https://www.linkedin.com/shareArticle?mini=true&url=';
      break;
    case "whatsapp":
        shareUrl = 'https://web.whatsapp.com://send?text=';
      break;
    case "email":
      popUpWindow = false;
      shareUrl = 'mailto:?subject=Great%20blog%20post&body=';
      break;
    default: console.log('wrong social media prop');
  }

  shareWindowSize = () => {
    let w = Math.min(640, screen.width - 32),
        h = Math.min(480, screen.height - 32),
        l = (screen.width - w) / 2,
        t = (screen.height - h) / 2
    return `width=${w},height=${h},left=${l},top=${t}`;
  }

  if (popUpWindow) {
    window.open(shareUrl + location.href, '_blank', shareWindowSize());
  } else {
    window.open(shareUrl + location.href);
  }

}
